module.exports = __webpack_public_path__ + "media/the-wilton-area-is.3dbe7aa0.mp4";